export const WITHDRAW_EMAIL_MAX_LENGTH = 120;
